<template>
  <div>
    <p style="font-size: 20px; font-weight: 600; margin: 20px 0 20px 0">
      施工超期排行榜
    </p>
    <div style="display: flex; justify-content: start; margin: 20px 0 0 5px">
      <el-select
        :clearable="true"
        v-model="city"
        placeholder="选择城市"
        class="littleBox inputStyle"
        @change="choseCity3(city)"
        style="height: 30px !important"
        filterable
      >
        <el-option
          v-for="(item, index) in cities"
          :key="index"
          :label="item.city"
          :value="item.city_id"
        ></el-option>
      </el-select>
      <el-select
        :clearable="true"
        v-if="city != ''"
        v-model="shopper"
        placeholder="选择店长"
        class="littleBox rankStyle inputStyle"
        @change="choseShopkeeper3(shopper)"
        filterable
      >
        <el-option
          v-for="(item, index) in shoppers"
          :key="index"
          :label="item.username"
          :value="item.user_id"
        ></el-option>
      </el-select>
      <el-select
        :clearable="true"
        v-if="city != ''"
        v-model="store"
        placeholder="选择店铺"
        class="littleBox rankStyle inputStyle"
        @change="choseStore3(store)"
        filterable
      >
        <el-option
          v-for="(item, index) in stores"
          :key="index"
          :label="item.store_name"
          :value="item.store_name"
        ></el-option>
      </el-select>
      <div>
        <span style="margin: 0 10px 0 20px; font-size: 14px">下单时间:</span>
        <el-date-picker
          v-model="create_time3"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="datePicker"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
      <el-button
        type="primary"
        size="small"
        plain
        @click="getBuildList"
        style="margin-left: 20px"
        >筛选</el-button
      >
    </div>
    <avue-crud
      :data="tableData3"
      :option="option3"
      v-model="obj3"
      style="margin-top: 15px"
    >
      <template slot="overtime" slot-scope="scope">
        <div>{{ scope.row.overtime }}天</div>
      </template>
    </avue-crud>
    <div class="flex_start mt20 flex_items">
      <span class="demonstration mr20">
        总共
        <span style="color: red">{{ count3 }}</span
        >条数据,当前 <span style="color: red">{{ tableData3.length }}</span
        >条
      </span>
      <el-pagination
        @current-change="handleCurrentChange3"
        :current-page.sync="currentPage3"
        :page-size="20"
        :total="count3"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  //   props: {
  //     mobile: Number
  //   },
  data() {
    return {
      active: 0,
      city: "",
      cities: [],
      shopper: "",
      shoppers: [],
      store: "",
      stores: [],
      create_time3: "",
      count3: 0,
      tableData3: [],
      option3: {
        border: true,
        size: "medium",
        menu: false,
        page: false,
        align: "left",
        dateBtn: false,
        dateDefault: false,
        addBtn: false,
        columnBtn: false, //列显隐按钮
        refreshBtn: false, //刷新按钮
        //   delBtn:false,
        //   editBtn:false,
        column: [
          {
            label: "店长",
            prop: "username",
            width: "150px",
          },
          {
            label: "店铺",
            prop: "store_name",
            width: "100px",
          },
          {
            label: "订单号",
            prop: "order_id",
          },
          {
            label: "工地地址",
            prop: "addres",
          },
          {
            label: "客户姓名",
            prop: "contacts",
            width: "100px",
          },
          {
            label: "客户电话",
            prop: "telephone",
            width: "130px",
          },
          {
            label: "下单时间",
            prop: "created_time",
            type: "date",
            format: "yyyy-MM-dd hh:mm:ss",
            valueFormat: "yyyy-MM-dd hh:mm:ss",
            sortable: true,
          },
          {
            label: "开工时间",
            prop: "start_time",
            type: "date",
            format: "yyyy-MM-dd hh:mm:ss",
            valueFormat: "yyyy-MM-dd hh:mm:ss",
          },
          {
            label: "超时时间",
            prop: "overtime",
            slot: true,
            sortable: true,
          },
        ],
      },
      obj3: {},
      currentPage3: 1,
      time3: 0,
    };
  },
  created() {
    this.getCity();
    this.getBuildList();
  },
  watch: {},
  methods: {
    getCity() {
      //获取城市
      this.util.get(this.HOST + "/Common/cheng", {}).then((res) => {
        if (res.code == 200) {
          this.cities = res.data;
          this.cities5 = res.data;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
            duration: 1200,
            offset: 90,
          });
        }
      });
    },
    choseCity3(city) {
      //选择城市-施工超期
      this.shopper = "";
      this.store = "";
      this.getShopper(city);
      this.getStores(city);
      this.getBuildList();
    },
    getShopper(city) {
      //获取店长
      this.util
        .get(this.HOST + "/Common/user", {
          city_id: city,
        })
        .then((res) => {
          if (res.code == 200) {
            this.shoppers = res.data;
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    getStores(city) {
      //获取选取城市的店铺
      this.util
        .get(this.HOST + "/Common/store", {
          city_id: city,
        })
        .then((res) => {
          //console.log(res, "stores++++");
          if (res.code == 200) {
            this.stores = res.data;
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    getBuildList() {
      //施工超期排行榜
      this.$loading(this.util.opload);
      if (this.create_time3 == null || this.create_time3 == "") {
        this.create_time3 = "";
      }
      let time_start = this.util.datatime(this.create_time3[0]);
      let time_end = this.util.datatime(this.create_time3[1]);
      if (time_start == "NaN-NaN-NaN NaN:NaN:NaN") {
        time_start = "";
        time_end = "";
      }
      this.util
        .get(this.HOST + "/Order/Construction", {
          page: 1,
          limit: 20,
          user_id: this.shopper,
          store_id: this.store,
          city_id: this.city,
          desc: this.time3,
          time_start: time_start,
          time_end: time_end,
        })
        .then((res) => {
          if (res.code == 200) {
            this.count3 = res.data.count;
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].clock_in_time = this.util.timestampToTime(
                res.data.list[i].clock_in_time
              );
            }
            this.tableData3 = res.data.list;
            this.$loading().close();
          } else {
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    handleCurrentChange3(val) {
      if (this.create_time3 == null || this.create_time3 == "") {
        this.create_time3 = "";
      }
      let time_start = this.util.datatime(this.create_time3[0]);
      let time_end = this.util.datatime(this.create_time3[1]);
      if (time_start == "NaN-NaN-NaN NaN:NaN:NaN") {
        time_start = "";
        time_end = "";
      }
      this.$loading(this.util.opload);
      this.tableData3 = [];
      this.util
        .get(this.HOST + "/Order/Construction", {
          limit: 20,
          user_id: "",
          store_id: "",
          city_id: "",
          page: this.currentPage3,
          desc: this.time3,
          time_start: time_start,
          time_end: time_end,
        })
        .then((res) => {
          if (res.code == 200) {
            this.count3 = res.data.count;
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].clock_in_time = this.util.timestampToTime(
                res.data.list[i].clock_in_time
              );
              this.tableData3 = res.data.list;
            }
            this.$loading().close();
          } else {
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    choseShopkeeper3(value) {
      //选择店长之后的操作-施工超期
      this.getBuildList();
    },
    choseStore3(value) {
      //选择店铺之后-施工超期
      this.getBuildList();
    },
  },
};
</script>
<style scoped>
.content {
  margin: 0 auto;
  background: white;
  padding: 10px 0 0 30px;
  border-radius: 8px;
  height: 100%;
}
.child {
  width: 24%;
  margin-bottom: 10%;
}
.number {
  font-size: 26px;
  /* text-align: center; */
  color: #999;
  margin: 5% 0 0 25%;
}
.title {
  font-size: 16px;
  margin-top: 20px;
  text-align: left;
  color: #666;
  width: 145px;
}
.sort {
  margin-bottom: -20px;
}
.rankStyle {
  margin-left: 20px;
}
.selectedTime {
  color: #409eff;
}
.returnIcon:hover {
  color: cornflowerblue;
}
div /deep/ .avue-crud__menu {
  min-height: 0px !important;
}
.el-icon-warning:hover span {
  display: block;
}
::v-deep .datePicker {
  width: 256px;
  height: 32px !important;
  line-height: 32px !important;
}
::v-deep .littleBox input {
  height: 32px !important;
  line-height: 32px !important;
  width: 160px;
}
.active1 {
  display: none;
}
.active2 {
  display: inline;
}
</style>
